import { useLayoutEffect } from "react";
import PropTypes from "prop-types";

// Applies document-level token overrides while mounted. The attribute belongs
// on <html> because GlobalStyle themes both <html> and <body>.

export default function DocumentTheme({ name }) {
  useLayoutEffect(() => {
    document.documentElement.dataset.junoTheme = name;
    return () => {
      delete document.documentElement.dataset.junoTheme;
    };
  }, [name]);

  return null;
}

DocumentTheme.propTypes = {
  name: PropTypes.oneOf(["estate-agent", "probate"]).isRequired,
};
